import { createSlice } from '@reduxjs/toolkit';
import {
  createPaymentRequestExtraReducer,
  deletePaymentRequestExtraReducer,
  getPaymentRequestDetailsForPaymentExtraReducer,
  getPaymentRequestsExtraReducer,
  paymentRequestFiservPaymentExtraReducer,
  paymentRequestPaymentExtraReducer,
  resendPaymentRequestExtraReducer,
  updatePaymentRequestExtraReducer,
} from '../reducers/paymentRequestsReducer';
import { DillPaymentRequestResponse } from '@dill/dill-shared';

export interface PaymentRequestsInitialState {
  loadingList: string[];
  paymentRequests: DillPaymentRequestResponse[];
}

const initialState: PaymentRequestsInitialState = {
  loadingList: [],
  paymentRequests: [],
};

export const paymentRequestsSlice = createSlice({
  name: 'paymentRequests',
  initialState,
  reducers: {
    resetPaymentRequestsRootState: () => initialState,
  },
  extraReducers(builder) {
    createPaymentRequestExtraReducer(builder);
    getPaymentRequestsExtraReducer(builder);
    getPaymentRequestDetailsForPaymentExtraReducer(builder);
    paymentRequestPaymentExtraReducer(builder);
    paymentRequestFiservPaymentExtraReducer(builder);
    resendPaymentRequestExtraReducer(builder);
    updatePaymentRequestExtraReducer(builder);
    deletePaymentRequestExtraReducer(builder);
  },
});

export const { resetPaymentRequestsRootState } = paymentRequestsSlice.actions;
